/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditScheduleNoteDialog/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import TimegridScheduleNote from 'DesignSystem/TimegridScheduleNote/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EditScheduleNoteDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note/EditScheduleNoteDialog",
  contentRef,
  top,
  left,
  onClose
  
}) {
let eventShowEditDialogValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'show_edit_dialog',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let eventScheduleNoteValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'schedule_note',
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={eventShowEditDialogValueData}>
<div
  data-testid="EditScheduleNoteDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 style={{'--t-1-Z1fzWsk': typeof top === 'number' ? `${top}px` : top,'--l-2-Z1fzWsk': typeof left === 'number' ? `${left}px` : left,'--bc-3-Z1fzWsk': dtColorsWhite,'--pl-4-Z1fzWsk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-5-Z1fzWsk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-6-Z1fzWsk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-7-Z1fzWsk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-Z1fzWsk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-9-Z1fzWsk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-10-Z1fzWsk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-11-Z1fzWsk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-12-Z1fzWsk': dtColorsNeutral200,'--g-13-Z1fzWsk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<TimegridScheduleNote
  viewPath={`${viewPath}/TimegridScheduleNote`}
 data="event.schedule_note"
 schedule_note={eventScheduleNoteValueData}
 onComplete={onClose}
/>
</div>
</fromFlow.When>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}